import { ISearchableObject } from "./rz-status_models";

/**
* Class that can be used to search within an array of ISearchableObjects
* @author Joerg Peschke, etone Intermedia Gmbh & Co KG
**/
export default class SearchEngine {
	searchField:HTMLInputElement;
	searchTerm:string = "";
	searchData:ISearchableObject[];
	fields:string[];
	results:ISearchableObject[] = [];

	/**
	* Constructor
	* @param fields an array of fields that the search engine should evaluate for it's search
	**/
	constructor (fields:string[]) {		
		this.fields = fields;		
	}
	/**
	* Sets the data on which the search enginge operates
	* @param data an array of searchable objects
	**/
	public setData (data:ISearchableObject[]):void {
		this.searchData = data;		
	}

	public setSearchTerm(searchTerm:string):void {
		this.searchTerm = searchTerm;
	}

	/**
	* Perform a search with a certain search term
	* @param searchTerm a search term
	**/
	public search():void {		
		if (this.searchTerm.match(/^\s*?$/)) {
			this.results = this.searchData;
			return;
		}
		this.results = [];
		for (var i:number=0; i<this.searchData.length; i++) {
			if (this.searchData[i].matchesSearch (this.searchTerm, this.fields)) {
				this.results.push(this.searchData[i]);
			}
		}
		
	}
	/**
	* Return all results that were found during the last search
	* @return an array of ISearchableObjects that were found during the last search
	**/
	public getResults():ISearchableObject[] {
		return(this.results);
	}
}